/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-07-07 15:15:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-14 19:23:01
 * @FilePath: /src/app/payment/components/Points/components/JoinFreeDialog.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';

import { postJoinMember } from '@/api/account';
import { toast } from '@/components/Toast';
import { useReporting } from '@/hooks/useReporting';
import { useStore } from '@/providers/app-store-provider';
import { ProviderType } from '@/reporting';
import logger from '@/utils/client-logger';
import { getRouteCnName } from '@/utils/route-metadata';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';

interface JoinFreeDialogProps {
  onSuccess?: () => void;
}

export default function JoinFreeDialog({ onSuccess }: JoinFreeDialogProps) {
  const pathname = usePathname();
  const router = useRouter();
  const { trackEvent } = useReporting();
  const refreshAccountInfo = useStore((state) => state.refreshAccountInfo);
  const isInPayment = pathname === '/payment';
  const { show } = useStore((state) => state.joinFreeDialogInfo);
  const setJoinFreeDialogInfo = useStore((state) => state.setJoinFreeDialogInfo);
  const setIsGlobalLoading = useStore((state) => state.setIsGlobalLoading);
  const onClose = () => {
    setJoinFreeDialogInfo({
      show: false,
    });
  };

  useEffect(() => {
    if (show) {
      register();
    }
  }, [show]);

  const onJoinMemberSuccess = () => {
    // 入会的统一行为 ：请求信息且刷新，入会成功后，跳转到会员中心
    if (pathname === '/account/zeelool-rewards') {
      router.push('/account/zeelool-rewards');
    }
  };

  // 提交
  const register = async () => {
    try {
      setIsGlobalLoading(true);
      const response = await postJoinMember({});
      if (response.code === 200) {
        onSuccess?.();
        if (!isInPayment) {
          await refreshAccountInfo();
          toast.success('Welcome to ZEELOOL Rewards!');
          onJoinMemberSuccess?.();
        }
      } else {
        window.location.reload();
      }
    } catch (error) {
      logger.log(error);
    } finally {
      setTimeout(() => {
        onClose();
        setIsGlobalLoading(false);
      }, 500);
    }
    SDFreeJoinMemberClick();
  };

  const SDFreeJoinMemberClick = () => {
    try {
      const sdEventName = 'FreeJoinMember_Click';
      const sdEventParams = {
        page_name: getRouteCnName(location.pathname),
        url_path: window.location.href,
      };
      trackEvent(
        {
          eventName: sdEventName,
          properties: sdEventParams,
        },
        [ProviderType.SENSORS],
      );
    } catch (e) {
      logger.log(e);
    }
  };

  return null;
}
